 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		16: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		16: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"c65dd12f1bd5e993a2b83f3cc3f6c153ef4990aa","2":"310eaafaf5838f5df300caf71dda0e91c6a8de98","3":"ad841617998428d4a81aab9da7572d7dc9a3c5b0","4":"component---src-pages-primer-index-js","5":"13a6374a7471f37fb58e2e84523d14dbbaa8344f","6":"769abd986b8232295fdade5b336986b09afec6d1","7":"db9985e06178d38f57aa71f1145aed6fc3a2adf9","8":"e84da1bd7e36f3fcef5e617c242c80c9110ef29f","9":"28417453c330b4679bcd9c43fded2aa9541344a6","10":"678613e273b772476ff20b106eb626767da290cb","11":"f425a01b716e10cc463c7534fbf14b7b3d26fa02","12":"917cfc574e2e76ae06f7c96522d41241d2cde2e5","13":"f22cf21d81c6d6d287a6b67bbfaa018ba488f75c","14":"1f5f20e4a04417f6de56067ad393b1ac543ee606","15":"e98749e07d83c43b0c6ce3dcf385ecf4fa835194","17":"153b761b","18":"4598a128","19":"8a3ad8a8","20":"8debdcb0","21":"9c3cb768","23":"b12acb91","24":"component---src-pages-404-js","25":"component---src-pages-about-index-js","26":"component---src-pages-acropolis-index-js","27":"component---src-pages-alexandria-index-js","28":"component---src-pages-antioch-index-js","29":"component---src-pages-athens-index-js","30":"component---src-pages-babylon-index-js","31":"component---src-pages-brand-assets-index-js","32":"component---src-pages-brand-guides-index-js","33":"component---src-pages-brand-story-index-js","34":"component---src-pages-carthage-index-js","35":"component---src-pages-community-index-js","36":"component---src-pages-constantinople-index-js","37":"component---src-pages-dashboard-index-js","38":"component---src-pages-get-started-index-js","39":"component---src-pages-giza-index-js","40":"component---src-pages-glossary-index-js","41":"component---src-pages-hydra-index-js","42":"component---src-pages-index-js","43":"component---src-pages-manifesto-index-js","44":"component---src-pages-olympia-index-js","45":"component---src-pages-privacy-policy-index-js","46":"component---src-pages-rhodes-index-js","47":"component---src-pages-roadmap-index-js","48":"component---src-pages-rome-index-js","49":"component---src-pages-sparta-index-js","50":"component---src-pages-sumer-index-js","51":"component---src-pages-testnet-community-bounties-js","52":"component---src-pages-testnet-index-js","53":"component---src-pages-testnet-live-kp-is-js","54":"component---src-pages-testnet-loader-js","55":"component---src-pages-testnet-pending-exchanges-js","56":"component---src-pages-testnet-token-stats-js","57":"component---src-pages-token-index-js","58":"component---src-templates-verification-js","59":"ecf0d064"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"3ae02905a555518bcfd7","2":"309d23fe9e076fff5663","3":"74dbbb2bcb22c3f54fc2","4":"3d49b58148b7b15283e1","5":"ea3a4e0bed36fb94690b","6":"3279b9d658871f61bad2","7":"c7173ce4b0a6167cf4bb","8":"89193370c1ffa483b70f","9":"f48fa08fc4443701293b","10":"f255042778c2509c8246","11":"fc723dc1bfcc2618aa21","12":"b46e62189f671640d606","13":"18d73f8feb62c1332b69","14":"4a3529895f28e5318533","15":"845646bf3fe6a80282d3","17":"d121aee86711bef7e8ea","18":"df957407b044d6aadea2","19":"7a229c5a4bdc1aac8fd8","20":"7ce3b75dbc02e957bb37","21":"b1aff039f977a4ad9196","23":"cf75605e06f11c7a8d02","24":"f33656669c1ab12116bb","25":"b9dbb5d23115206034bb","26":"9281607ebe4f6bd13607","27":"5ea3ec2e64f8c4a38b47","28":"141010e6fa1d48ddaf31","29":"ed21e58ce0b1b8abd3eb","30":"79a8693ad39f1f8dca22","31":"dd0850cb71ccf5f054ef","32":"88f76b17bbbd8c72b6bb","33":"7182215f5e509c0e58c8","34":"9c4cde54ddac00070c64","35":"662558fedcf59a4a7537","36":"d2b7d980e49fe5bd6743","37":"d10bf42983dc9d423549","38":"1daf132d780308b00223","39":"66e8a93ffbd433b9344d","40":"3fd4b25c12dc3eae387f","41":"80067c402628ee959ab8","42":"86edba62f778e6858998","43":"ea37c3f5607ef962b1ea","44":"2ca95f6048e2d4040bb2","45":"4292a220116999bb5b12","46":"14014a1dd17a75a8becd","47":"ce3191ffb73b0db98bf7","48":"3c693b696c74d9c6975a","49":"90efaec5108c145eea72","50":"dd680b5088729fc8d4db","51":"f71a34ac36a4c8b63c3d","52":"7c6ff78f04e0897d02af","53":"68c2c5aeeec7fa115276","54":"c2fda5d1df03bbd87d0e","55":"cdd784e9f67c3bfbb3ae","56":"0f556ec8bc99d5920bc3","57":"14d34456dba14670c004","58":"c8a28b8bb1117c35aaef","59":"b30bc04fb5bd2316b649","62":"53cf69692a1d98ebbf20","63":"5448dff14d3927cec4e0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"c65dd12f1bd5e993a2b83f3cc3f6c153ef4990aa","2":"310eaafaf5838f5df300caf71dda0e91c6a8de98","3":"ad841617998428d4a81aab9da7572d7dc9a3c5b0","4":"component---src-pages-primer-index-js","5":"13a6374a7471f37fb58e2e84523d14dbbaa8344f","6":"769abd986b8232295fdade5b336986b09afec6d1","7":"db9985e06178d38f57aa71f1145aed6fc3a2adf9","8":"e84da1bd7e36f3fcef5e617c242c80c9110ef29f","9":"28417453c330b4679bcd9c43fded2aa9541344a6","10":"678613e273b772476ff20b106eb626767da290cb","11":"f425a01b716e10cc463c7534fbf14b7b3d26fa02","12":"917cfc574e2e76ae06f7c96522d41241d2cde2e5","13":"f22cf21d81c6d6d287a6b67bbfaa018ba488f75c","14":"1f5f20e4a04417f6de56067ad393b1ac543ee606","15":"e98749e07d83c43b0c6ce3dcf385ecf4fa835194","17":"153b761b","18":"4598a128","19":"8a3ad8a8","20":"8debdcb0","21":"9c3cb768","23":"b12acb91","24":"component---src-pages-404-js","25":"component---src-pages-about-index-js","26":"component---src-pages-acropolis-index-js","27":"component---src-pages-alexandria-index-js","28":"component---src-pages-antioch-index-js","29":"component---src-pages-athens-index-js","30":"component---src-pages-babylon-index-js","31":"component---src-pages-brand-assets-index-js","32":"component---src-pages-brand-guides-index-js","33":"component---src-pages-brand-story-index-js","34":"component---src-pages-carthage-index-js","35":"component---src-pages-community-index-js","36":"component---src-pages-constantinople-index-js","37":"component---src-pages-dashboard-index-js","38":"component---src-pages-get-started-index-js","39":"component---src-pages-giza-index-js","40":"component---src-pages-glossary-index-js","41":"component---src-pages-hydra-index-js","42":"component---src-pages-index-js","43":"component---src-pages-manifesto-index-js","44":"component---src-pages-olympia-index-js","45":"component---src-pages-privacy-policy-index-js","46":"component---src-pages-rhodes-index-js","47":"component---src-pages-roadmap-index-js","48":"component---src-pages-rome-index-js","49":"component---src-pages-sparta-index-js","50":"component---src-pages-sumer-index-js","51":"component---src-pages-testnet-community-bounties-js","52":"component---src-pages-testnet-index-js","53":"component---src-pages-testnet-live-kp-is-js","54":"component---src-pages-testnet-loader-js","55":"component---src-pages-testnet-pending-exchanges-js","56":"component---src-pages-testnet-token-stats-js","57":"component---src-pages-token-index-js","58":"component---src-templates-verification-js","59":"ecf0d064"}[chunkId]||chunkId) + "." + {"0":"d8375ed9dd960c3ad082","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
